module.exports = __webpack_public_path__ + "static/global_banner-12b22091f345572fb59b54ea1887f5d3.jpg";